import { mapState, mapActions } from 'vuex';
import FileSaver from 'file-saver';
// import Spinner from 'vue-simple-spinner';
import GlobalSelector from './GlobalSelector';
import DashboardHeader from './DashboardHeader';
import ViewButtons from './ViewButtons';
import StratFilters from './StratFilters';
// import VisualizationTitle from './VisualizationTitle';
import TableView from './TableView';
import MapViewContainer from './MapViewContainer';
import ChartView from './ChartView';
import PanelFootnotes from './PanelFootnotes';
import PageFootnotes from '../common/PageFootnotes';
import TempDisplayRawLPData from './TempDisplayRawLPData';
import Interactions from './Interactions';
import api from '../../api';

/* eslint-disable */
export default {
  name: 'LargePanel',
  components: {
    GlobalSelector,
    DashboardHeader,
    ViewButtons,
    StratFilters,
    TableView,
    MapViewContainer,
    ChartView,
    PanelFootnotes,
    PageFootnotes,
    TempDisplayRawLPData,
    Interactions,
  },
  created() {
    this.setStateFromQueryStringParms();
  },
  computed: {
    ...mapState({
      showHeadingsAndFilters: state => state.LP.flags.showHeadingsAndFilters,
      showFootnotes: state => state.LP.flags.showFootnotes,
      view: state => state.LP.view,
      GSGo: state => state.LP.GSGo,
      indicatorId: state => state.LP.indicatorId,
      stratFilters: state => state.LP.stratFilters,
      apiErrors: state => state.apiErrors,
      dataErrors: state => state.dataErrors,
      questionData: state => state.LP.questionData,
      lpData: state => state.LP.lpData,
      lku: state => state.lku,
      generatingPdf: state => state.SP.flags.generatingPdf,
      showMode: state => state.flags.showMode,
    }),
    testURL() {
      return 'http://localhost:8080/LP?' + this.queryStringForExportToPdf + '&showMode=export';
    },
    indicator() {
      const row = this.lku.Question[this.indicatorId];
      return row ? row.abbr : '';
    },
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    showWaitSpinner() {
      return this.$store.getters.showWaitSpinner;
    },
    queryStringForExportToPdf() {
      return this.$store.getters['LP/queryStringForExportToPdf'];
    },
  },
  mounted() {
    if (this.printerFriendly) {
      if (document.readyState === "loading") {
        this.$nextTick().then(
          setTimeout(function() {
              document.addEventListener("DOMContentLoaded", window.print())
            },
            5000
          )
        );
      } else {
        this.$nextTick().then(
          setTimeout(function() {
              document.addEventListener("DOMContentLoaded", window.print())
            },
            5000
          )
        );
      };
    }
  },
  methods: {

    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
    setStateFromQueryStringParms() {
      this.$store.commit('LP/setView', this.getDefaultFromQueryStringParmIfInitialPageLoad('Map', 'View'));
      this.$store.commit('LP/setShowFootnotes', this.getDefaultFromQueryStringParmIfInitialPageLoad('true', 'ShowFootnotes') === 'true');
      this.$store.commit('LP/setMapClassifierId', this.getDefaultFromQueryStringParmIfInitialPageLoad('quantile', 'MapClassifierId'));
      this.$store.commit('LP/setMapClassifierCount', this.getDefaultFromQueryStringParmIfInitialPageLoad('5', 'MapClassifierCount'));
    },
    ...mapActions([
      'getInitialApiData',
    ]),
    saveAsPdf() {
      // console.log('queryString: ' + this.queryStringForExportToPdf);
      if (!this.generatingPdf) {
        this.$store.commit('LP/setInteractionTypeIfEmpty', 'IE PDF');
        this.$store.commit('LP/setGeneratingPdf', true);
        const url = `${window.location.protocol}//${window.location.host}/LP?${this.queryStringForExportToPdf}&showMode=export`;
        
        console.log(url);
        window.open(url, "_blank");
        this.$store.commit('LP/setGeneratingPdf', false);

        // api.post('ExportToPDF', {
        //   exportFormat: 1, // 1: PDF, 2: PDFLandscape
        //   myVirtualDirectoryOnDev: process.env.MyVirtualDirectoryOnDev,
        //   urlToRender: `MyVirtualDirectory/LP?${this.queryStringForExportToPdf}&showMode=export`,
        //   exportFileName: 'Export.pdf',
        //   conversionDelaySec: 10,
        // }, {
        //   responseType: 'blob',
        // }).then((response) => {
        //   FileSaver.saveAs(response.data, 'Export.pdf');
        //   this.$store.commit('LP/setGeneratingPdf', false);
        // }).catch((err) => {
        //   // console.log(err);
        //   this.$notify({
        //     type: 'error',
        //     title: 'Export error',
        //     text: `Export to PDF failed: ${err.response.status} ${err.response.statusText}`,
        //   });
        //   this.$store.commit('LP/setGeneratingPdf', false);
        // });
      }
    },
    exportToCsv() {
      this.$store.commit('LP/setInteractionTypeIfEmpty', 'IE EX');
      const csv = this.$store.getters['LP/csvExport'](this.lpData, this.stratFilters.multistrat, this.indicator);
      // console.log(csv);
      const blob = new Blob([csv], { type: 'text/html;charset=utf-8' });
      FileSaver.saveAs(blob, 'Export.csv');
    },
  },
  watch: {
    apiErrors() {
      if (this.apiErrors.length > 0) {
        const err = this.apiErrors[this.apiErrors.length - 1];
        this.$notify({
          type: 'error',
          title: 'API error',
          text: `${err.request.responseURL} ${err.message}`,
        });
      }
    },
    dataErrors() {
      if (this.dataErrors.length > 0) {
        this.dataErrors.forEach((error) => {
          this.$notify({
            type: 'error',
            title: 'Data error',
            text: error,
          });
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/LP/LargePanels1.js